import personIcon from "../../icons/personIcon.svg";
import logout from "../../icons/logout.svg";
import styles from './dropdown.module.css'

export const buttonsData = (accFunc, togglePopup, navigate) => [
  {
    id: "account",
    label: "Account",
    icon: personIcon,
    className: styles.accountBtn,
    onClick: accFunc,
  },
  {
    id: "privacy",
    label: "Privacy Settings",
    icon: personIcon,
    className: styles.accountBtn,
    onClick: () => navigate('/privacy-dashboard'),
  },
  {
    id: "logout",
    label: "Log Out",
    icon: logout,
    className: styles.accountLogout,
    onClick: togglePopup,
  },
];